import React from "react";
import { useNavigate } from "react-router-dom";

export default function OperationsHub() {
  const navigate = useNavigate();

  const items = [
    {
      title: "Create Complaint / Service",
      description: "Log a new customer complaint or schedule a general maintenance service request.",
      route: "/create-complaint",
      icon: "post_add",
      color: "bg-blue-100 text-blue-700",
    },
    {
      title: "Complaints & Services List",
      description: "View and manage all active, pending, and completed service complaints or operations.",
      route: "/complaints",
      icon: "assignment_turned_in",
      color: "bg-emerald-100 text-emerald-700",
    },
    {
      title: "Travel Monitoring",
      description: "Track engineer travel status, departure status, and live site check-ins in real-time.",
      route: "/admin/travel",
      icon: "navigation",
      color: "bg-amber-100 text-amber-700",
    },
    {
      title: "Daily Updates",
      description: "Review field work progress, photos, and update reports submitted daily by engineers.",
      route: "/admin/daily-updates",
      icon: "event_note",
      color: "bg-violet-100 text-violet-700",
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <span className="font-label-caps text-[11px] text-primary uppercase mb-1 block">ADMIN WORKSPACE</span>
        <h1 className="font-headline-lg text-headline-lg text-on-surface">Operations</h1>
        <p className="text-sm text-outline mt-1">Select an operation below to manage complaints, updates, and tracking.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {items.map((item) => (
          <button
            key={item.route}
            onClick={() => navigate(item.route)}
            className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-primary/30 transition-all text-left flex items-start gap-4 active:scale-[0.98] w-full"
          >
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${item.color}`}>
              <span className="material-symbols-outlined text-2xl">{item.icon}</span>
            </div>
            <div className="flex-1 space-y-1">
              <h3 className="text-base font-bold text-on-surface flex items-center justify-between">
                {item.title}
                <span className="material-symbols-outlined text-outline-variant text-sm group-hover:text-primary">arrow_forward</span>
              </h3>
              <p className="text-sm text-outline leading-relaxed">{item.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
